import { DATE_PRESET_LABELS, DATE_PRESET_OPTIONS } from '@shared/lib/date-range'
import type { DatePreset, DateRangeValue } from '@shared/lib/date-range'
import { DateField } from '../DateField/DateField'
import { SegmentedControl } from '../SegmentedControl/SegmentedControl'
import type { SegmentedOption } from '../SegmentedControl/SegmentedControl'
import { customRow, presets, root } from './DateRangeField.css'

export type DateRangeFieldProps = {
  value: DateRangeValue
  onChange: (value: DateRangeValue) => void
  allLabel?: string
}

const presetOptions: ReadonlyArray<SegmentedOption<DatePreset>> = DATE_PRESET_OPTIONS.map(
  (preset) => ({ value: preset, label: DATE_PRESET_LABELS[preset] }),
)

export function DateRangeField({ value, onChange, allLabel }: DateRangeFieldProps) {
  return (
    <div className={root}>
      <SegmentedControl
        className={presets}
        value={value.preset}
        options={presetOptions.map((option) =>
          option.value === 'all' && allLabel ? { ...option, label: allLabel } : option,
        )}
        ariaLabel="Período"
        onChange={(preset) => onChange({ ...value, preset })}
      />
      {value.preset === 'custom' ? (
        <div className={customRow}>
          <DateField
            label="De"
            value={value.from ?? ''}
            onChange={(event) => onChange({ ...value, from: event.target.value || null })}
          />
          <DateField
            label="Até"
            value={value.to ?? ''}
            onChange={(event) => onChange({ ...value, to: event.target.value || null })}
          />
        </div>
      ) : null}
    </div>
  )
}
